import React from "react";
import { Button } from "./Button";

interface PageHeaderProps {
  title: React.ReactNode;
  onExit?: () => void;
  showSettings?: boolean;
  onSettingsClick?: () => void;
  forceHardExit?: boolean;
  showBlockedMessage?: boolean; // NEW: Add prop to show blocked message
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  onExit,
  showSettings = false,
  onSettingsClick,
  forceHardExit = false,
  showBlockedMessage = false, // NEW: Add prop to show blocked message
}) => {
  // Enhanced exit handler that can force a hard navigation
  const handleExit = () => {
    if (onExit) {
      // Call the provided exit handler first (for any cleanup)
      onExit();
    }

    // If hard exit is requested, force a full page navigation
    if (forceHardExit) {
      // Small delay to ensure cleanup completes
      setTimeout(() => {
        // Force hard navigation by setting window.location directly
        window.location.href = "/";
      }, 100);
    }
  };

  const handleExitClick = () => {
    if (showBlockedMessage) {
      // Could show a toast or alert here
      console.log("Exit blocked - please confirm scan results first");
      return;
    }
    handleExit();
  };

  return (
    <div className="flex justify-between items-center mb-6 bg-white p-4 rounded-lg shadow-sm">
      <h1 className="text-2xl font-bold text-[#00212F]">{title}</h1>
      <div className="flex items-center gap-3">
        {showSettings && onSettingsClick && (
          <button
            onClick={onSettingsClick}
            className="p-2 text-gray-600 hover:text-[#00212F] focus:outline-none transition-colors"
            title="Settings"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          </button>
        )}

        {onExit && (
          <Button
            variant="danger"
            onClick={handleExitClick}
            className={
              showBlockedMessage ? "opacity-50 cursor-not-allowed" : ""
            }
          >
            Exit
          </Button>
        )}
      </div>
    </div>
  );
};
